var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect, Suspense, Fragment, useRef } from 'react';
import { Grid } from '@material-ui/core';
import MainLayout from '../../layouts/MainLayout';
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import { getMetrics } from '../../services/widget-service';
import { checkRoleUser, getCurrentUser, getPublishersByCurrentUser, getPublisherSelectedByCurrentUser, checkInternalUser } from '../../utils/CommonUtil';
import { createReportGroup, createReportType, updateReportGroup, updateReportType, getReportTypes, requiredDimension, getReportGroupsById, deleteReportType, loadDefaultSetting } from '../../services/report-service';
import { publisherData } from '../../store/publisher/reducer';
import Checkbox from '../../components/common/checkbox/Checkbox';
import ChipMetrics from './components/chip-metrics';
import ToggleSwitch from '../../components/common/switch/switch';
import { presentations, presentationsMultipleCharts, metricTypeIDList } from '../../utils/ChartUtil';
import ChipWrapper from './components/chip-wrapper';
import PlusIcon from "../../assets/icons/plus.svg";
import RemoveIcon from "../../assets/icons/delete2.svg";
import { validate } from '../../utils/ValidationUtil';
import * as Constant from '../../utils/Constant';
import { metricsGA, metricDimensionRequiredByGA, metricNonDimensionByGA } from '../../utils/ReportUtil';
import CheckBoxList from '../../components/common/check-box-list/checkBoxList';
import SelectMaterial from '../../components/common/select-material/SelectMaterial';
import IconButton from '@material-ui/core/IconButton';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import { DialogDefault as DialogConfirm } from '../../components/common/dialog/Dialog';
import { updateDefaultSetting } from '../../store/publisher/actions';
import './index.scss';
import { storeCurrentMenuItemPosition, storeCurrentParentMenuItemPosition } from '../../store/header/actions';
var EActionType;
(function (EActionType) {
    EActionType["Create"] = "create";
    EActionType["Edit"] = "edit";
})(EActionType || (EActionType = {}));
var LazyFilterPanel = React.lazy(function () { return import('../report/components/ReportSettingPanel'); });
var ReportSettingPanel = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyFilterPanel, __assign({}, props)));
};
var LazyPreviewReportWrapper = React.lazy(function () { return import('./components/preview-report'); });
var PreviewReportWrapper = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyPreviewReportWrapper, __assign({}, props)));
};
var Loading = function () { return React.createElement("div", null, "Loading..."); };
var ReportPage = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var user = getCurrentUser();
    var _a = useState([]), metricList = _a[0], setMetricList = _a[1];
    var _b = useState([]), publisherList = _b[0], setPublisherList = _b[1];
    var _c = useState(), publisherIds = _c[0], setPublisherIds = _c[1];
    var _d = useState(-1), isPreviewReport = _d[0], setPreviewReport = _d[1];
    var _e = useState(""), messageReportSuccess = _e[0], setMessageReportSuccess = _e[1];
    var _f = useState(""), messageReportError = _f[0], setMessageReportError = _f[1];
    var _g = useState(""), builderType = _g[0], setBuilderType = _g[1];
    var _h = useState(true), loadingBuilder = _h[0], setLoadingBuilder = _h[1];
    var _j = useState(false), isDeleteReportType = _j[0], setDeleteReportType = _j[1];
    var _k = useState(null), dataDeleteReportType = _k[0], setDataDeleteReportType = _k[1];
    var _l = useState(""), messageDeleteSuccess = _l[0], setMessageDeleteSuccess = _l[1];
    var _m = useState(""), messageDeleteError = _m[0], setMessageDeleteError = _m[1];
    var _o = useState(), filterSettingData = _o[0], setFilterSettingData = _o[1];
    var _p = useState(null), reportGroupOriginal = _p[0], setReportGroupOriginal = _p[1];
    var _q = useState(null), reportTypeOriginals = _q[0], setReportTypeOriginals = _q[1];
    var _r = useState(false), isloadingBuilderUpdate = _r[0], setLoadingBuilderUpdate = _r[1];
    var _s = useState({
        name: "",
        description: "",
        descriptionExternal: "",
        displayDashboard: "PUBLISHER",
        publisherIds: [],
        showPlatformFilter: true,
        showPlatformList: true,
        applyForAll: false,
        status: "ACTIVE"
    }), reportGroupData = _s[0], setReportGroupData = _s[1];
    var _t = useState([
        {
            name: "",
            description: "",
            displayOrder: 0,
            presentationType: "SINGLE_TABLE",
            reportGroupId: "",
            showMetrics: true,
            publisherList: [],
            metricList: [],
            metricSelectedList: [],
            presentationList: [],
            presentationMultipleChartList: [],
            dimensionList: [],
            dimensionValid: [],
            reportTypeMetrics: [],
            requestCount: true,
            displayPlatformNameType: "SHOW_ALL",
            reportTypeMethod: "STANDARD",
            status: "ACTIVE",
            isPreviewReport: false,
            isValidatePlatformReport: false
        }
    ]), reportTypeData = _t[0], setReportTypeData = _t[1];
    var _u = useState({
        reportType: null,
        reportGroup: null
    }), errorList = _u[0], setErrors = _u[1];
    var _v = useState(false), isLoadingPreviewReport = _v[0], setLoadingPreviewReport = _v[1];
    var validateOption = {
        reportGroup: {
            name: {
                type: Constant.VALIDATION_TYPE_TEXT,
                value: "",
                name: t("report_builder.report_group_name")
            }
        },
        reportType: {
            name: {
                type: Constant.VALIDATION_TYPE_TEXT_NOT_SPECIAL_CHARACTER,
                value: "",
                name: t("report_builder.report_type_name")
            },
            presentationType: {
                type: Constant.VALIDATION_TYPE_TEXT,
                value: "",
                name: t("report_builder.presentation_type")
            }
        }
    };
    var date = new Date();
    var _w = useState([
        {
            startDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30),
            endDate: new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1),
            key: 'selection'
        }
    ]), duration = _w[0], setDuration = _w[1];
    var _x = useState(false), isResetReportSetting = _x[0], setResetReportSetting = _x[1];
    var _y = useState([]), sortMedias = _y[0], setSortMedias = _y[1];
    var _z = useState([]), sortPlatforms = _z[0], setSortPlatforms = _z[1];
    var _0 = useState([]), sortInventories = _0[0], setSortInventories = _0[1];
    var _1 = useState([]), sortPlatformInventories = _1[0], setSortPlatformInventories = _1[1];
    var _2 = useState([]), sortSubPlatformGroups = _2[0], setSortSubPlatformGroups = _2[1];
    var _3 = useState([]), sortPlatformGroups = _3[0], setSortPlatformGroups = _3[1];
    var _4 = useState(false), isOpenDialogGAValidation = _4[0], setOpenDialogGAValidation = _4[1];
    var _5 = useState(false), isExistingDefaultSetting = _5[0], setExistingDefaultSetting = _5[1];
    var _6 = useState(false), isSaveDefaultSetting = _6[0], setIsSaveDefaultSetting = _6[1];
    var _7 = useState(null), defaultSetting = _7[0], setDefaultSetting = _7[1];
    var _8 = useState(), defaultSettingRequest = _8[0], setDefaultSettingRequest = _8[1];
    var _9 = useState(false), openConfirmModal = _9[0], setOpenConfirmModal = _9[1];
    var _10 = useState(EActionType.Create), actionType = _10[0], setActionType = _10[1];
    var _11 = useState(""), messageSaveDefaultSettingSuccess = _11[0], setMessageSaveDefaultSettingSuccess = _11[1];
    var _isMounted = useRef(true);
    useEffect(function () {
        if (props.match && props.match.params && props.match.params.reportGroupId) {
            var reportGroupId = props.match.params.reportGroupId;
            var reportBuilderType = props.match.params.reportGroupType;
            getReportGroup(reportGroupId, reportBuilderType);
        }
        else {
            var reportGroup = {
                name: "",
                description: "",
                displayDashboard: "PUBLISHER",
                publisherIds: [],
                showPlatformFilter: true,
                showPlatformList: true,
                applyForAll: false,
                status: "ACTIVE"
            };
            getMetricList(reportGroup, "create");
        }
        props.dispatch(storeCurrentMenuItemPosition({ position: 1 }));
        props.dispatch(storeCurrentParentMenuItemPosition({ position: 0 }));
        document.title = t("page.report_builder") + Constant.APP_NAME;
        return (function () {
            _isMounted.current = false;
        });
    }, []);
    useEffect(function () {
        if (props.publisherData && props.publisherData) {
            var publisher = getPublisherSelectedByCurrentUser();
            handlePublisherSelected(publisher);
        }
    }, [props.publisherData]);
    var handlePublisherSelected = function (publisher) {
        if (publisher) {
            setPublisherIds([publisher.id]);
        }
    };
    var getReportGroup = function (id, builderType) { return __awaiter(void 0, void 0, void 0, function () {
        var reportGroup, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getReportGroupsById(id)];
                case 1:
                    reportGroup = _a.sent();
                    getMetricList(reportGroup, builderType);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log("Error Get Report Group By ID", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getMetricList = function (reportGroup, builderType) { return __awaiter(void 0, void 0, void 0, function () {
        var metrics, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getMetrics()];
                case 1:
                    metrics = _a.sent();
                    // if (user.type == "EXTERNAL") {
                    //   metrics = metrics.filter((metric: any) => metric.publisherVisibility == "DEFAULT_FOR_ALL" || metric.publisherVisibility == "PUBLISHER_ONLY" );
                    // } else {
                    //   metrics = metrics.filter((metric: any) => metric.publisherVisibility == "DEFAULT_FOR_ALL" || metric.publisherVisibility == "INTERNAL_USER" )
                    // }
                    getPublisherList(reportGroup, metrics, builderType);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log("Error Metric", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getPublisherList = function (reportGroup, metrics, builderType) { return __awaiter(void 0, void 0, void 0, function () {
        var publisherCheckbox, publishers, publisherChecked, currentPublisher;
        return __generator(this, function (_a) {
            try {
                publisherCheckbox = [];
                publishers = getPublishersByCurrentUser();
                if (publishers) {
                    if (user.type == "EXTERNAL") {
                        if (builderType == "create" || builderType == "clone") {
                            publisherCheckbox = publishers.map(function (publisher) {
                                publisher.isCheck = true;
                                return publisher;
                            });
                        }
                        else if (builderType == "edit") {
                            publisherCheckbox = publishers.map(function (publisher) {
                                var foundPublisher = null;
                                if (reportGroup && reportGroup.publishers) {
                                    foundPublisher = reportGroup.publishers.find(function (publisherReportGroup) { return publisherReportGroup.id == publisher.id; });
                                }
                                publisher.isCheck = foundPublisher ? true : false;
                                return publisher;
                            });
                        }
                        reportGroup["applyForAll"] = false;
                        reportGroup["publisherIds"] = publisherCheckbox.map(function (publisher) { return publisher.id; });
                    }
                    else {
                        publisherCheckbox = publishers.map(function (publisher) {
                            var foundPublisher = null;
                            if (reportGroup && reportGroup.publishers) {
                                foundPublisher = reportGroup.publishers.find(function (publisherReportGroup) { return publisherReportGroup.id == publisher.id; });
                            }
                            publisher.isCheck = foundPublisher ? true : false;
                            return publisher;
                        });
                    }
                }
                publisherCheckbox = _.sortBy(publisherCheckbox, "name");
                if (publisherCheckbox) {
                    publisherChecked = publisherCheckbox.filter(function (publisher) { return publisher.isCheck; });
                    reportGroup["publisherIds"] = publisherChecked.map(function (publisher) { return publisher.id; });
                    if (builderType == "clone") {
                        reportGroup["applyForAll"] = user.type == "EXTERNAL" ? false : reportGroup.applyForAll;
                    }
                }
                currentPublisher = getPublisherSelectedByCurrentUser();
                if (currentPublisher) {
                    setPublisherIds([currentPublisher.id]);
                    loadDefaultSettingByReportGroup(currentPublisher.id, reportGroup);
                }
                getReportTypeList(reportGroup, metrics, publisherCheckbox, builderType);
            }
            catch (error) {
                console.log("Get Publisher Error: ", error);
            }
            return [2 /*return*/];
        });
    }); };
    var getReportTypeList = function (reportGroup, metrics, publishers, builderType) { return __awaiter(void 0, void 0, void 0, function () {
        var params, reportTypes, reportTypeList, presentationLists, presentationMultipleChartLists, reportData, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {};
                    if (reportGroup && reportGroup.id) {
                        params.reportGroupIds = reportGroup.id;
                    }
                    return [4 /*yield*/, getReportTypes(params)];
                case 1:
                    reportTypes = _a.sent();
                    reportTypeList = reportTypes.filter(function (reportType) { return reportType.reportGroup.id == reportGroup.id; });
                    if (reportTypeList && reportTypeList.length) {
                    }
                    else {
                        reportTypeList = _.cloneDeep(reportTypeData);
                    }
                    presentationLists = getPresentationList(presentations);
                    presentationMultipleChartLists = getPresentationList(presentationsMultipleCharts);
                    reportTypeList = reportTypeList.map(function (reportType) {
                        if (builderType == "clone") {
                            reportType.name = reportType.name ? reportType.name + " - Copy" : "Copy";
                            delete (reportType.id);
                        }
                        reportType.isPreviewReport = false;
                        reportType.isValidatePlatformReport = false;
                        reportType.publisherList = _.cloneDeep(publishers);
                        reportType.showMetrics = true;
                        reportType.metricList = _.cloneDeep(metrics);
                        reportType.presentationList = _.cloneDeep(presentationLists);
                        reportType.presentationMultipleChartList = _.cloneDeep(presentationMultipleChartLists);
                        if (!reportType.id && !reportType.name) {
                            reportType.presentationList = (reportType.presentationList || []).map(function (reportTypePresentation) {
                                if (reportTypePresentation.id == "SINGLE_TABLE") {
                                    reportTypePresentation.selected = true;
                                }
                                return reportTypePresentation;
                            });
                        }
                        return reportType;
                    });
                    reportTypeList = _.sortBy(reportTypeList, "displayOrder");
                    if (builderType == "clone") {
                        reportGroup.name = reportGroup.name ? reportGroup.name + " - Copy" : "Copy";
                        delete (reportGroup.id);
                    }
                    //start mapping report group
                    if (!checkRoleAdminAndOperator()) {
                        reportGroup.displayDashboard = "PUBLISHER";
                    }
                    delete (reportGroup.updatedDate);
                    delete (reportGroup.publishers);
                    reportData = buildDataReportType(reportTypeList, builderType);
                    setBuilderType(builderType);
                    setReportGroupData(reportGroup);
                    setPublisherList(publishers);
                    setMetricList(metrics);
                    setReportTypeData(reportData);
                    setLoadingBuilder(false);
                    setReportGroupOriginal(reportGroup);
                    setReportTypeOriginals(reportData);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    console.log("Error Get report type");
                    setLoadingBuilder(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var buildDataReportType = function (reportTypes, builderType) {
        var reportData = reportTypes.map(function (reportType, index) {
            reportType.displayOrder = index;
            var foundPresentationType = reportType.presentationList.findIndex(function (presentationType) { return presentationType.id == reportType.presentationType; });
            if (foundPresentationType > -1) {
                reportType.presentationList[foundPresentationType].selected = true;
            }
            else {
                var foundPresentationTypeMulti = reportType.presentationMultipleChartList.findIndex(function (presentationType) { return presentationType.id == reportType.presentationType; });
                if (foundPresentationTypeMulti > -1)
                    reportType.presentationMultipleChartList[foundPresentationTypeMulti].selected = true;
            }
            reportType.metricSelectedList = [];
            reportType.dimensionList = [];
            reportType.dimensionValid = [];
            reportType.reportTypeMetrics = reportType.reportTypeMetrics.map(function (metric) {
                var idMetric = metric.advertisingMetric.id;
                delete (metric.advertisingMetric);
                if (builderType == "clone")
                    delete (metric.id);
                return __assign(__assign({}, metric), { metricId: idMetric });
            });
            var isChart = reportType.presentationType.indexOf("CHART") > -1;
            reportType.metricList = reportType.metricList.map(function (metric) {
                var foundMetricSelected = reportType.reportTypeMetrics.find(function (metricSelected) { return metricSelected.metricId == metric.id; });
                if (foundMetricSelected) {
                    metric.selected = true;
                    var metricSelected = __assign(__assign({}, metric), { displayOrder: foundMetricSelected.displayOrder });
                    reportType.metricSelectedList.push(metricSelected);
                    if (foundMetricSelected.isDimension) {
                        reportType.dimensionList.push(metric);
                        reportType.dimensionValid.push(metric);
                    }
                }
                else {
                    metric.selected = false;
                }
                if (isChart) {
                    var foundMetricTypeId = metricTypeIDList.find(function (metricTypeID) { return metricTypeID.field == metric.defaultCollectionField; });
                    if (foundMetricTypeId) {
                        metric.isBlockChart = true;
                    }
                    else {
                        metric.isBlockChart = false;
                    }
                }
                return metric;
            });
            var dataMetricSelecteds = reportType.metricSelectedList ? __spreadArrays(reportType.metricSelectedList) : [];
            reportType.metricSelectedList = _.orderBy(dataMetricSelecteds, "displayOrder");
            delete (reportType.reportGroup);
            return reportType;
        });
        return reportData;
    };
    var getPresentationList = function (dataPresentation) {
        var presentationUtil = JSON.parse(dataPresentation);
        presentationUtil = presentationUtil.map(function (presention) {
            presention.name = t("report_builder." + presention.name.toLowerCase());
            presention.selected = false;
            return presention;
        });
        return presentationUtil;
    };
    var changePresentationType = function (presentation, reportTypeIndex, isMultiple) {
        setPreviewReport(-1);
        var reportTypes = _.cloneDeep(reportTypeData);
        if (reportTypes[reportTypeIndex]) {
            var foundSelected = presentation.find(function (pres) { return pres.selected; });
            if (foundSelected) {
                reportTypes[reportTypeIndex].presentationType = foundSelected.id;
                var isChart = foundSelected.id.indexOf("CHART") > -1;
                if (reportTypes[reportTypeIndex].metricList && reportTypes[reportTypeIndex].metricList.length) {
                    if (isChart) {
                        reportTypes[reportTypeIndex].metricList = reportTypes[reportTypeIndex].metricList.map(function (metric) {
                            var foundMetricTypeId = metricTypeIDList.find(function (metricTypeID) { return metricTypeID.field == metric.defaultCollectionField; });
                            if (foundMetricTypeId) {
                                metric.isBlockChart = true;
                                if (metric.selected) {
                                    var foundMetricSelectedList = (reportTypes[reportTypeIndex].metricSelectedList || []).findIndex(function (metricSelectedItem) { return metricSelectedItem.defaultCollectionField == metric.defaultCollectionField; });
                                    if (foundMetricSelectedList > -1) {
                                        reportTypes[reportTypeIndex].metricSelectedList.splice(foundMetricSelectedList, 1);
                                        var foundMetricDimensionList = (reportTypes[reportTypeIndex].dimensionList || []).findIndex(function (metricDimensionItem) { return metricDimensionItem.defaultCollectionField == metric.defaultCollectionField; });
                                        if (foundMetricDimensionList > -1 && reportTypes[reportTypeIndex].dimensionList[foundMetricDimensionList].dimensionAble) {
                                            reportTypes[reportTypeIndex].dimensionList.splice(foundMetricDimensionList, 1);
                                        }
                                    }
                                    metric.selected = false;
                                }
                            }
                            else {
                                metric.isBlockChart = false;
                            }
                            return metric;
                        });
                    }
                    else {
                        reportTypes[reportTypeIndex].metricList = reportTypes[reportTypeIndex].metricList.map(function (metric) {
                            delete (metric.isBlockChart);
                            return metric;
                        });
                    }
                }
                if (isMultiple) {
                    var presentationLists = getPresentationList(presentations);
                    reportTypes[reportTypeIndex].presentationList = _.cloneDeep(presentationLists);
                    reportTypes[reportTypeIndex].presentationMultipleChartList = presentation;
                }
                else {
                    var presentationMultipleChartLists = getPresentationList(presentationsMultipleCharts);
                    reportTypes[reportTypeIndex].presentationList = presentation;
                    reportTypes[reportTypeIndex].presentationMultipleChartList = _.cloneDeep(presentationMultipleChartLists);
                }
                if (reportTypes[reportTypeIndex] && reportTypes[reportTypeIndex].dimensionList.length) {
                    var metricDimension = _.cloneDeep(reportTypes[reportTypeIndex].metricSelectedList);
                    metricDimension = (metricDimension || []).filter(function (metric) { return metric.dimensionAble; });
                    metricDimension = metricDimension.map(function (metric) {
                        metric.selected = false;
                        return metric;
                    });
                    reportTypes[reportTypeIndex].dimensionList = metricDimension;
                    requiredDimensionFromPresentationType(reportTypes, reportTypeIndex, foundSelected.id);
                }
                else {
                    setReportTypeData(reportTypes);
                }
            }
        }
    };
    var requiredDimensionFromPresentationType = function (reportTypes, reportTypeIndex, prentationSelected) { return __awaiter(void 0, void 0, void 0, function () {
        var params, dimensionData_1, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        presentationType: prentationSelected,
                        dimensionIds: ""
                    };
                    params.dimensionIds = reportTypes[reportTypeIndex].dimensionList.map(function (dimension) { return dimension.id; });
                    params.dimensionIds = params.dimensionIds.join();
                    return [4 /*yield*/, requiredDimension(params)];
                case 1:
                    dimensionData_1 = _a.sent();
                    dimensionData_1.forEach(function (dimension) {
                        var foundIndexMetricList = reportTypes[reportTypeIndex].metricList.findIndex(function (metric) { return metric.id == dimension.id; });
                        var foundIndexMetricSelected = reportTypes[reportTypeIndex].metricSelectedList.find(function (metric) { return metric.id == dimension.id; });
                        if (foundIndexMetricList > -1) {
                            reportTypes[reportTypeIndex].metricList[foundIndexMetricList].selected = true;
                        }
                        if (!foundIndexMetricSelected) {
                            reportTypes[reportTypeIndex].metricSelectedList.push(dimension);
                        }
                        if (prentationSelected.indexOf("LINE") == -1) {
                            reportTypes[reportTypeIndex].dimensionList.push(dimension);
                        }
                    });
                    if (prentationSelected.indexOf("LINE") > -1) {
                        reportTypes[reportTypeIndex].dimensionList = dimensionData_1;
                    }
                    reportTypes[reportTypeIndex].dimensionList = _.uniqBy(reportTypes[reportTypeIndex].dimensionList, "id");
                    reportTypes[reportTypeIndex].dimensionList.forEach(function (metric, index) {
                        var foundMetricDimension = dimensionData_1.find(function (dimension) { return metric.id == dimension.id; });
                        if (foundMetricDimension) {
                            metric.selected = true;
                        }
                        else {
                            metric.selected = false;
                        }
                    });
                    reportTypes[reportTypeIndex].dimensionValid = dimensionData_1;
                    reportTypes[reportTypeIndex].dimensionList = _.sortBy(reportTypes[reportTypeIndex].dimensionList || [], function (dimension) { return dimension.id; });
                    changeRequireDimension(reportTypes, reportTypes[reportTypeIndex].dimensionList, reportTypeIndex);
                    setReportTypeData(reportTypes);
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.log("Error Require dimension:", error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onChangePublisher = function (publishers, checkAllPublisher) {
        if (reportGroupData.applyForAll)
            return;
        var reportGroup = __assign({}, reportGroupData);
        var publisherChecked = publishers.filter(function (publisher) { return publisher.isCheck; });
        if (publishers) {
            setErrors(function (current) {
                if (current.reportGroup === null)
                    return;
                var _a = current.reportGroup, publisherIds = _a.publisherIds, rest = __rest(_a, ["publisherIds"]);
                current.reportGroup = rest;
            });
            setErrors(errorList);
        }
        reportGroup["publisherIds"] = publisherChecked.map(function (publisher) { return publisher.id; });
        setReportGroupData(reportGroup);
        setPublisherList(publishers);
    };
    var onChangeMetrics = function (metrics, reportTypeIndex) {
        if (metrics) {
            setErrors(function (current) {
                if (current && current.reportType) {
                    var _a = current.reportType[reportTypeIndex], reportTypeMetrics = _a.reportTypeMetrics, rest = __rest(_a, ["reportTypeMetrics"]);
                    if (reportTypeMetrics === undefined)
                        return;
                    current.reportType[reportTypeIndex] = rest;
                }
            });
            setErrors(errorList);
        }
        if (metrics) {
            var reportTypes = _.cloneDeep(reportTypeData);
            var metricDimension = _.cloneDeep(metrics);
            metricDimension = metricDimension.filter(function (metric) { return metric.dimensionAble; });
            metricDimension = metricDimension.map(function (metric) {
                metric.selected = false;
                return metric;
            });
            reportTypes[reportTypeIndex]["metricSelectedList"] = metrics;
            reportTypes[reportTypeIndex]["dimensionList"] = metricDimension;
            if (reportTypes[reportTypeIndex] && reportTypes[reportTypeIndex].presentationType && reportTypes[reportTypeIndex].dimensionList.length) {
                requiredDimensionFromPresentationType(reportTypes, reportTypeIndex, reportTypes[reportTypeIndex].presentationType);
            }
            else {
                changeRequireDimension(reportTypes, metricDimension, reportTypeIndex);
                setReportTypeData(reportTypes);
            }
        }
    };
    var changeRequireDimension = function (reportTypes, metricDimension, reportTypeIndex) {
        reportTypes[reportTypeIndex].reportTypeMetrics = reportTypes[reportTypeIndex].metricSelectedList.map(function (metric, index) {
            var foundDimension = metricDimension.find(function (dimension) { return dimension.id == metric.id && dimension.selected; });
            var foundRecorId = reportTypes[reportTypeIndex].reportTypeMetrics.find(function (reportTypeMetric) { return reportTypeMetric.metricId == metric.id; });
            var foundFilterable = metricDimension.find(function (dimension) {
                if (dimension.id == metric.id && dimension.selected) {
                    if (reportTypes[reportTypeIndex].presentationType == Constant.PRESENTATION_TYPE_TABLE || metric.dataType != "DATE_TIME") {
                        return true;
                    }
                    else {
                        if (metric.dataType != "DATE_TIME") {
                            return true;
                        }
                    }
                }
                return false;
            });
            var alignment = "LEFT";
            if (metric.dataType == "TEXT") {
                alignment = "LEFT";
            }
            else if (metric.dataType == "DATE_TIME") {
                alignment = "CENTER";
            }
            else {
                alignment = "RIGHT";
            }
            return {
                alignmentType: alignment,
                displayOrder: index,
                filterable: foundFilterable ? true : false,
                id: builderType == "edit" && foundRecorId ? foundRecorId.id : null,
                isDefault: true,
                isDimension: foundDimension ? true : false,
                metricId: metric.id,
                status: "ACTIVE",
                sortDirection: null,
                sortOrder: null
            };
        });
    };
    var onChangeSelectedDimension = function (dimensions, reportTypeIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var reportTypes, oldSelectedDimensions, newSelectedDimensions, params, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reportTypes = _.cloneDeep(reportTypeData);
                    oldSelectedDimensions = _.cloneDeep(reportTypes[reportTypeIndex].dimensionList);
                    if (dimensions) {
                        setErrors(function (current) {
                            if (current && current.reportType) {
                                var _a = current.reportType[reportTypeIndex], isDimension = _a.isDimension, rest = __rest(_a, ["isDimension"]);
                                if (isDimension === undefined)
                                    return;
                                current.reportType[reportTypeIndex] = rest;
                            }
                        });
                        setErrors(errorList);
                    }
                    if (!(dimensions && reportTypes[reportTypeIndex])) return [3 /*break*/, 3];
                    newSelectedDimensions = dimensions.filter(function (dimension) { return dimension.selected; });
                    if (!((newSelectedDimensions === null || newSelectedDimensions === void 0 ? void 0 : newSelectedDimensions.length) < (oldSelectedDimensions === null || oldSelectedDimensions === void 0 ? void 0 : oldSelectedDimensions.length) && reportTypes[reportTypeIndex].presentationType && (dimensions === null || dimensions === void 0 ? void 0 : dimensions.length))) return [3 /*break*/, 2];
                    params = {
                        presentationType: reportTypes[reportTypeIndex].presentationType,
                        dimensionIds: dimensions.map(function (dimension) { return dimension.id; }).join()
                    };
                    _a = reportTypes[reportTypeIndex];
                    return [4 /*yield*/, requiredDimension(params)];
                case 1:
                    _a.dimensionValid = _b.sent();
                    _b.label = 2;
                case 2:
                    reportTypes[reportTypeIndex].dimensionList = dimensions;
                    reportTypes[reportTypeIndex].reportTypeMetrics = reportTypes[reportTypeIndex].metricSelectedList.map(function (metric, index) {
                        var foundDimension = dimensions.find(function (dimension) { return dimension.id == metric.id && dimension.selected; });
                        var foundRecorId = reportTypes[reportTypeIndex].reportTypeMetrics.find(function (reportTypeMetric) { return reportTypeMetric.metricId == metric.id; });
                        var foundFilterable = dimensions.find(function (dimension) {
                            if (dimension.id == metric.id && dimension.selected) {
                                if (reportTypes[reportTypeIndex].presentationType == Constant.PRESENTATION_TYPE_TABLE) {
                                    return true;
                                }
                                else {
                                    if (metric.dataType != "DATE_TIME") {
                                        return true;
                                    }
                                }
                            }
                            return false;
                        });
                        var alignment = "LEFT";
                        if (metric.dataType == "TEXT") {
                            alignment = "LEFT";
                        }
                        else if (metric.dataType == "DATE_TIME") {
                            alignment = "CENTER";
                        }
                        else {
                            alignment = "RIGHT";
                        }
                        return {
                            alignmentType: alignment,
                            displayOrder: index,
                            filterable: foundFilterable ? true : false,
                            id: builderType == "edit" && foundRecorId ? foundRecorId.id : null,
                            isDefault: true,
                            isDimension: foundDimension ? true : false,
                            metricId: metric.id,
                            status: "ACTIVE",
                            sortDirection: null,
                            sortOrder: null
                        };
                    });
                    setReportTypeData(reportTypes);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onChangeFieldReportGroup = function (field, value) {
        if (value) {
            setErrors(function (current) {
                if (current.reportGroup === null)
                    return;
                var _a = current.reportGroup, name = _a.name, rest = __rest(_a, ["name"]);
                current.reportGroup = rest;
            });
            setErrors(errorList);
        }
        var reportGroup = __assign({}, reportGroupData);
        reportGroup[field] = value;
        setReportGroupData(reportGroup);
    };
    var onChangeFieldReportType = function (field, value, reportTypeIndex) {
        if (value) {
            setErrors(function (current) {
                if (current.reportType === undefined || current.reportType === null)
                    return;
                var _a = current.reportType[reportTypeIndex], name = _a.name, rest = __rest(_a, ["name"]);
                current.reportType[reportTypeIndex] = rest;
            });
            setErrors(errorList);
        }
        var reportTypes = _.cloneDeep(reportTypeData);
        if (reportTypes[reportTypeIndex]) {
            reportTypes[reportTypeIndex][field] = value;
            setReportTypeData(reportTypes);
        }
    };
    var addReportType = function () {
        var reportTypes = _.cloneDeep(reportTypeData);
        var newReportType = {
            name: "",
            description: "",
            displayOrder: reportTypes.length && reportTypes[reportTypes.length - 1] ? reportTypes[reportTypes.length - 1]["displayOrder"] + 1 : 0,
            presentationType: "",
            reportGroupId: "",
            metricList: [],
            showMetrics: true,
            presentationList: [],
            publisherList: [],
            metricSelectedList: [],
            dimensionList: [],
            dimensionValid: [],
            reportTypeMetrics: [],
            requestCount: true,
            displayPlatformNameType: "SHOW_ALL",
            reportTypeMethod: "STANDARD",
            status: "ACTIVE"
        };
        newReportType.presentationList = getPresentationList(presentations);
        newReportType.presentationMultipleChartList = getPresentationList(presentationsMultipleCharts);
        newReportType.publisherList = _.clone(publisherList);
        var metricDimension = [];
        newReportType.metricList = (metricList || []).map(function (metric) {
            // if (checkDefaultMetricSelected(metric)) {
            //   metric.selected = true;
            //   newReportType.metricSelectedList.push(metric);
            //   if (metric.dimensionAble) {
            //     metricDimension.push(metric);
            //     newReportType.dimensionList.push(metric);
            //     newReportType.dimensionValid.push(metric);
            //   }
            // }
            return metric;
        });
        reportTypes.push(newReportType);
        if (metricDimension && metricDimension.length) {
            changeRequireDimension(reportTypes, metricDimension, reportTypes.length - 1);
        }
        setReportTypeData(reportTypes);
    };
    var onCloneReportType = function (reportType) {
        var reportTypeTemp = _.cloneDeep(reportType);
        var reportTypes = _.cloneDeep(reportTypeData);
        reportTypeTemp.displayOrder = reportTypes.length;
        reportTypeTemp.id = "";
        reportTypeTemp.name = reportTypeTemp.name ? reportTypeTemp.name + " - copy" : "Copy";
        reportTypeTemp.reportTypeMetrics = reportTypeTemp.reportTypeMetrics.map(function (reportTypeMetric) {
            reportTypeMetric.id = "";
            return reportTypeMetric;
        });
        reportTypes.push(reportTypeTemp);
        setReportTypeData(reportTypes);
    };
    var onDeleteReportType = function (index) {
        var reportTypes = _.cloneDeep(reportTypeData);
        if (builderType == "edit" && reportTypes[index].id && !disableEdit()) {
            setDataDeleteReportType(reportTypes[index]);
            setDeleteReportType(true);
        }
        else {
            reportTypes = reportTypes.reduce(function (acc, reportType, indexReportType) {
                if (indexReportType !== index) {
                    acc.push(__assign(__assign({}, reportType), { displayOrder: acc.length }));
                }
                return acc;
            }, []);
            setReportTypeData(reportTypes);
        }
    };
    var handleDeleteReportType = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id, reportTypes, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    id = dataDeleteReportType.id;
                    return [4 /*yield*/, deleteReportType(id)];
                case 1:
                    _a.sent();
                    reportTypes = reportTypeData.reduce(function (acc, reportType, index) {
                        if (reportType.id !== dataDeleteReportType.id) {
                            acc.push(__assign(__assign({}, reportType), { displayOrder: acc.length }));
                        }
                        return acc;
                    }, []);
                    setReportTypeData(reportTypes);
                    handleCloseDelete();
                    setMessageDeleteSuccess("Delete Report Type Success!");
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _a.sent();
                    console.log("Error Delete Report Type");
                    setMessageDeleteError("Delete Report Type Error!");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseDelete = function () {
        setDeleteReportType(false);
        setDataDeleteReportType(null);
    };
    var onChangeApplyForAll = function (value, checked) {
        if (checked) {
            setErrors(function (current) {
                if (current.reportGroup === null)
                    return;
                var _a = current.reportGroup, publisherIds = _a.publisherIds, rest = __rest(_a, ["publisherIds"]);
                current.reportGroup = rest;
            });
            setErrors(errorList);
        }
        var reportGroup = __assign({}, reportGroupData);
        reportGroup.applyForAll = checked;
        reportGroup.publisherIds = [];
        setReportGroupData(reportGroup);
    };
    var onShowMetricChip = function (index) {
        var reportTypes = _.cloneDeep(reportTypeData);
        reportTypes[index].showMetrics = !reportTypes[index].showMetrics;
        setReportTypeData(reportTypes);
    };
    var validateFormReportGroup = function () {
        var reportGroup = _.cloneDeep(reportGroupData);
        var isValid = true;
        var validateReportGroup = __assign({}, validateOption.reportGroup);
        Object.keys(validateReportGroup).forEach(function (reportGroupKey) {
            validateReportGroup[reportGroupKey].value = reportGroup[reportGroupKey] || "";
        });
        var error = validate(validateReportGroup);
        if (((checkRoleAdminAndOperator() && reportGroup.displayDashboard == "PUBLISHER") || !checkRoleAdminAndOperator()) && enablePublisher() && !reportGroup.applyForAll && (!reportGroup.publisherIds || !reportGroup.publisherIds.length)) {
            error["publisherIds"] = t("report_builder.report_group_publisher_label") + " is required";
        }
        var errorValidate = __assign({}, errorList);
        if (Object.keys(error).length) {
            errorValidate.reportGroup = error;
            setErrors(errorValidate);
            isValid = false;
        }
        else {
            isValid = validateFormReportType();
        }
        return isValid;
    };
    var validateFormReportType = function () {
        var reportTypes = _.cloneDeep(reportTypeData);
        var isValid = true;
        var errors = {};
        var errorValidate = __assign({}, errorList);
        var inValidGA = false;
        reportTypes.forEach(function (reportType) {
            var validateReportType = __assign({}, validateOption.reportType);
            Object.keys(validateReportType).forEach(function (reportTypeKey) {
                validateReportType[reportTypeKey].value = reportType[reportTypeKey] || "";
            });
            var error = validate(validateReportType);
            if (!reportType.metricSelectedList || !reportType.metricSelectedList.length) {
                error["reportTypeMetrics"] = t("report_builder.report_type_metriclabel") + " is required";
            }
            else {
                var foundDimensionSelected = reportType.dimensionList.find(function (metric) { return metric.selected; });
                if (!foundDimensionSelected) {
                    error["isDimension"] = t("report_builder.select_dimension_label") + " is required";
                }
                var inValidGAMetric = checkDimensionByGA(reportType, error);
                reportType.dimensionList.forEach(function (dimension) {
                    var foundDimension = reportType.dimensionValid.find(function (metric) { return dimension.id == metric.id; });
                    if (foundDimension && !dimension.selected) {
                        error["isDimension"] = t("report_builder.select_dimension_label") + " is inValid";
                        return;
                    }
                });
                if (inValidGAMetric)
                    inValidGA = true;
            }
            if (Object.keys(error).length) {
                isValid = false;
                errors[reportType.displayOrder] = error;
            }
        });
        errorValidate.reportGroup = null;
        errorValidate.reportType = errors;
        setErrors(errorValidate);
        if (inValidGA) {
            setOpenDialogGAValidation(true);
        }
        return isValid;
    };
    var checkDimensionByGA = function (reportType, error) {
        var inValidGAMetric = false;
        if (reportType) {
            var foundGAMetric = (reportType.metricSelectedList || []).find(function (metricSelected) {
                var foundMetricGA = metricsGA.find(function (metricGA) { return metricGA == metricSelected.defaultCollectionField; });
                if (foundMetricGA)
                    return true;
                return false;
            });
            if (foundGAMetric) {
                var foundGANoneMetric = (reportType.metricSelectedList || []).find(function (metricSelected) {
                    var foundMetricGA = metricNonDimensionByGA.find(function (metricNoneGA) {
                        if (metricNoneGA == metricSelected.defaultCollectionField) {
                            var foundDimensionNonByGA = (reportType.dimensionList || []).find(function (metricDimension) { return metricDimension && metricDimension.selected && metricDimension.defaultCollectionField == metricNoneGA; });
                            if (foundDimensionNonByGA)
                                return true;
                        }
                        return false;
                    });
                    if (foundMetricGA)
                        return true;
                    return false;
                });
                if (foundGANoneMetric) {
                    error["isMetricNoneGA"] = t("report_builder.GA_metrics_invalid");
                    inValidGAMetric = true;
                }
                else {
                    delete (error.isMetricNoneGA);
                }
                var foundValidDimensionMetric = (reportType.metricSelectedList || []).find(function (dimensionMetric) {
                    var foundDimensionGA = metricDimensionRequiredByGA.find(function (dimensionGA) { return dimensionGA == dimensionMetric.defaultCollectionField; });
                    if (foundDimensionGA)
                        return true;
                    return false;
                });
                if (foundValidDimensionMetric) {
                    delete (error.isDimensionGA);
                }
                else {
                    error["isDimensionGA"] = t("report_builder.dimension_GA_invalid");
                    inValidGAMetric = true;
                }
            }
        }
        return inValidGAMetric;
    };
    var validateForm = function (cbSave) {
        if (validateFormReportGroup()) {
            var errorDefault = {
                reportType: null,
                reportGroup: null
            };
            setErrors(errorDefault);
            return cbSave();
        }
        setIsSaveDefaultSetting(false);
        return;
    };
    var redirectReportPage = function () {
        history.push("/report");
    };
    var onSaveReportSetting = function (type, isConfirmedSaveDefaultSetting, defaultSettingData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (type == EActionType.Create) {
                if (!checkEnableCreateReport)
                    return [2 /*return*/];
            }
            else {
                if (!checkEnableEditReport)
                    return [2 /*return*/];
            }
            validateForm(function () { return __awaiter(void 0, void 0, void 0, function () {
                var paramReportGroup, idReportGroup, reportGroup_1, _a, reportTypeDatas, reportTypes, defaultSettingRequestTemp, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (isloadingBuilderUpdate)
                                return [2 /*return*/];
                            setLoadingBuilderUpdate(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 8, 9, 10]);
                            paramReportGroup = _.cloneDeep(reportGroupData);
                            idReportGroup = reportGroupData.id;
                            delete (paramReportGroup.id);
                            delete (paramReportGroup.creator);
                            delete (paramReportGroup.createdDate);
                            if (type == EActionType.Create && user && user.type === "EXTERNAL") {
                                paramReportGroup.description = "";
                            }
                            if (!(type == EActionType.Create || !idReportGroup)) return [3 /*break*/, 3];
                            return [4 /*yield*/, createReportGroup(paramReportGroup)];
                        case 2:
                            _a = _b.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, updateReportGroup(paramReportGroup, idReportGroup)];
                        case 4:
                            _a = _b.sent();
                            _b.label = 5;
                        case 5:
                            reportGroup_1 = _a;
                            reportTypeDatas = _.cloneDeep(reportTypeData);
                            reportTypes = reportTypeDatas.map(function (reportType) {
                                reportType.reportGroupId = reportGroup_1.id;
                                if (disableEdit() || type == EActionType.Create) {
                                    reportType.reportTypeMetrics = reportType.reportTypeMetrics.map(function (metric) {
                                        delete (metric.id);
                                        return metric;
                                    });
                                }
                                reportType.reportTypeMetrics = reportType.reportTypeMetrics.map(function (metric) {
                                    var foundMetric = reportType.metricSelectedList.find(function (metricSelected) { return metricSelected.id == metric.metricId; });
                                    if (foundMetric && foundMetric.dataType == "DATE_TIME" && reportType.presentationType != Constant.PRESENTATION_TYPE_TABLE) {
                                        metric.filterable = false;
                                    }
                                    return metric;
                                });
                                delete (reportType.metricSelectedList);
                                delete (reportType.dimensionList);
                                delete (reportType.presentationList);
                                delete (reportType.showMetrics);
                                delete (reportType.metricList);
                                delete (reportType.publisherList);
                                delete (reportType.presentationMultipleChartList);
                                delete (reportType.dimensionValid);
                                delete (reportType.isPreviewReport);
                                delete (reportType.isValidatePlatformReport);
                                return reportType;
                            });
                            reportTypes.forEach(function (reportType) { return __awaiter(void 0, void 0, void 0, function () {
                                var idReportType, _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            idReportType = reportType.id;
                                            delete (reportType.id);
                                            if (!(type == EActionType.Create || !idReportType)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, createReportType(reportType)];
                                        case 1:
                                            _a = _b.sent();
                                            return [3 /*break*/, 4];
                                        case 2: return [4 /*yield*/, updateReportType(reportType, idReportType)];
                                        case 3:
                                            _a = _b.sent();
                                            _b.label = 4;
                                        case 4:
                                            _a;
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            setMessageReportSuccess((type == EActionType.Create ? "Create" : "Update") + " Report Successfully!");
                            if (!(isConfirmedSaveDefaultSetting && defaultSettingData)) return [3 /*break*/, 7];
                            defaultSettingRequestTemp = _.cloneDeep(defaultSettingData);
                            if (type == EActionType.Create && defaultSettingRequestTemp) {
                                defaultSettingRequestTemp = __assign(__assign({}, defaultSettingRequestTemp), { reportGroupId: reportGroup_1.id });
                            }
                            return [4 /*yield*/, saveDefaultSetting(defaultSettingRequestTemp)];
                        case 6:
                            _b.sent();
                            _b.label = 7;
                        case 7:
                            setTimeout(function () {
                                redirectReportPage();
                            }, 1000);
                            return [3 /*break*/, 10];
                        case 8:
                            err_1 = _b.sent();
                            setMessageReportError("Create Report Error!");
                            console.log("Error Report: ", err_1);
                            return [3 /*break*/, 10];
                        case 9:
                            setIsSaveDefaultSetting(false);
                            return [7 /*endfinally*/];
                        case 10: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); };
    var onUpdateReportSetting = function (updateType) {
        setActionType(updateType);
        setIsSaveDefaultSetting(true);
    };
    var handleCloseAlert = function () {
        setMessageReportSuccess("");
        setMessageReportError("");
        setMessageDeleteError("");
        setMessageDeleteSuccess("");
        setMessageSaveDefaultSettingSuccess("");
    };
    var onLoadReportData = function (data, reportTypeIndex) {
        var reportTypes = _.cloneDeep(reportTypeData);
        if (!data || !data.platformGroups || (data.platformGroups && !data.platformGroups.length)) {
            reportTypes[reportTypeIndex].isValidatePlatformReport = true;
            setPreviewReport(-1);
            setReportTypeData(reportTypes);
            return;
        }
        reportTypes = reportTypes.map(function (reportType, index) {
            reportType.isValidatePlatformReport = false;
            reportType.isPreviewReport = index == reportTypeIndex;
            return reportType;
        });
        setFilterSettingData(data);
        setReportTypeData(reportTypes);
    };
    var updateDuration = function (duration) {
        setDuration(duration);
    };
    var disableEdit = function () {
        if ((user.type == "EXTERNAL" && reportGroupData.publisherIds && reportGroupData.publisherIds.length > 1) ||
            (user.type == "EXTERNAL" && reportGroupData.creator && reportGroupData.creator.id != user.id) ||
            (user.type == "INTERNAL" && !checkRoleUser(Constant.ROLE_SUPER_ADMIN))) {
            return true;
        }
        return false;
    };
    var enablePublisher = function () {
        if (checkRoleUser(Constant.ROLE_SUPER_ADMIN) && (builderType == "clone" || builderType == "create" || (user && reportGroupData && reportGroupData.creator && user.id == reportGroupData.creator.id))) {
            return true;
        }
        return false;
    };
    var checkEnableCreateReport = function () {
        if (user && user.type == "INTERNAL") {
            return true;
        }
        if (user && user.type === "EXTERNAL" && checkRoleUser(Constant.ROLE_ADMIN) || checkRoleUser(Constant.ROLE_MEDIA_MEMBER)) {
            return true;
        }
        return false;
    };
    var checkEnableEditReport = function () {
        if (user && user.type == "INTERNAL") {
            return true;
        }
        if (user && user.type === "EXTERNAL" && (reportGroupData && reportGroupData.creator && user.id == reportGroupData.creator.id) && (checkRoleUser(Constant.ROLE_ADMIN) || checkRoleUser(Constant.ROLE_MEDIA_MEMBER))) {
            return true;
        }
        return false;
    };
    var onChangeSortData = function (type, data) {
        switch (type) {
            case "MEDIA":
                setSortMedias(data);
                break;
            case "PLATFORM":
                setSortPlatforms(data);
                break;
            case "PUBDESK_INVENTORY":
                setSortInventories(data);
                break;
            case "PLATFORM_INVENTORY":
                setSortPlatformInventories(data);
                break;
            case "SUBPLATFORM_GROUP":
                setSortSubPlatformGroups(data);
                break;
            case "PLATFORM_GROUP":
                setSortPlatformGroups(data);
                break;
        }
        ;
    };
    var handleCloseOpenDialogGA = function () {
        setOpenDialogGAValidation(false);
    };
    var renderErrorMetrics = function (reportType) {
        if (errorList && errorList["reportType"] && errorList["reportType"][reportType.displayOrder]) {
            if (errorList["reportType"][reportType.displayOrder]["reportTypeMetrics"]) {
                return errorList["reportType"][reportType.displayOrder]["reportTypeMetrics"];
            }
            else if (errorList["reportType"][reportType.displayOrder]["isMetricNoneGA"]) {
                return errorList["reportType"][reportType.displayOrder]["isMetricNoneGA"];
            }
        }
        return "";
    };
    var renderErrorDimension = function (reportType) {
        if (errorList && errorList["reportType"] && errorList["reportType"][reportType.displayOrder]) {
            if (errorList["reportType"][reportType.displayOrder]["isDimension"]) {
                return errorList["reportType"][reportType.displayOrder]["isDimension"];
            }
            else if (errorList["reportType"][reportType.displayOrder]["isDimensionGA"]) {
                return errorList["reportType"][reportType.displayOrder]["isDimensionGA"];
            }
        }
        return "";
    };
    var checkRoleAdminAndOperator = function () {
        if (checkRoleUser(Constant.ROLE_SUPER_ADMIN) || checkRoleUser(Constant.ROLE_OPERATOR)) {
            return true;
        }
        return false;
    };
    var incrementReportOrder = function (index) {
        if (index && index > 0) {
            var reportTypes = _.clone(reportTypeData);
            reportTypes[index].displayOrder = index - 1;
            reportTypes[index - 1].displayOrder = index;
            reportTypes = _.sortBy(reportTypes, "displayOrder");
            setReportTypeData(reportTypes);
        }
    };
    var decrementReportOrder = function (index) {
        if (reportTypeData.length && index < (reportTypeData.length - 1)) {
            var reportTypes = _.clone(reportTypeData);
            reportTypes[index].displayOrder = index + 1;
            reportTypes[index + 1].displayOrder = index;
            reportTypes = _.sortBy(reportTypes, "displayOrder");
            setReportTypeData(reportTypes);
        }
    };
    var checkDisplayScheduleReportSetting = function (reportType) {
        if (reportGroupOriginal && reportGroupOriginal.status === "ACTIVE" && reportType) {
            var foundReportTypeIndex = (reportTypeOriginals || []).findIndex(function (reportTypeOriginal) { return reportTypeOriginal.presentationType === "SINGLE_TABLE" && reportTypeOriginal.id === reportType.id && reportTypeOriginal.status === "ACTIVE"; });
            return foundReportTypeIndex > -1;
        }
        return false;
    };
    var onClickSaveDefaultSetting = function (defaultSettingData, forceLoadData) {
        if (!defaultSettingData)
            return;
        if (!publisherIds || publisherIds.length > 1)
            return;
        setDefaultSettingRequest(defaultSettingData);
        if (isExistingDefaultSetting && actionType === EActionType.Edit) {
            setOpenConfirmModal(true);
        }
        else {
            onSaveReportSetting(actionType, true, defaultSettingData);
        }
    };
    var saveDefaultSetting = function (defaultData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            props.dispatch(updateDefaultSetting(defaultData));
            return [2 /*return*/];
        });
    }); };
    var loadDefaultSettingByReportGroup = function (publisherId, reportGroup) { return __awaiter(void 0, void 0, void 0, function () {
        var defaultSettingData, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!reportGroup) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadDefaultSetting(publisherId, reportGroup.id)];
                case 2:
                    defaultSettingData = _a.sent();
                    if (_isMounted.current) {
                        if (defaultSettingData && defaultSettingData.publisherId) {
                            setExistingDefaultSetting(true);
                            setDefaultSetting(defaultSettingData);
                        }
                        else {
                            setDefaultSetting(null);
                            setExistingDefaultSetting(false);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_6 = _a.sent();
                    console.error("Error loadDefaultSetting", error_6);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCloseConfirmModal = function () {
        setOpenConfirmModal(false);
        onSaveReportSetting(actionType, false);
    };
    var onSaveDefaultSetting = function () {
        setOpenConfirmModal(false);
        onSaveReportSetting(actionType, true, defaultSettingRequest);
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "report-builder-container" },
            React.createElement(Dialog, { open: loadingBuilder, title: 'Loading', PaperProps: {
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        overflow: 'hidden'
                    },
                } },
                React.createElement(CircularProgress, { className: "loading-progress" })),
            React.createElement(Dialog, { open: isDeleteReportType, onClose: handleCloseDelete, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", BackdropProps: {
                    classes: {
                        root: "dialog-calendar-backdrop"
                    }
                } },
                React.createElement(DialogTitle, { id: "alert-dialog-title" }, "Delete Report Type"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, "Are you sure delete this report type ?")),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: handleCloseDelete, color: "primary" }, "Cancel"),
                    React.createElement(Button, { onClick: handleDeleteReportType, color: "primary", autoFocus: true }, "OK"))),
            React.createElement("div", { className: "top-page-section" },
                React.createElement("div", { className: "page-title" },
                    React.createElement("div", { className: "widget-details-title" }, t("report_builder.title")))),
            React.createElement(Grid, { className: "widget-details-content", container: true, spacing: 2 },
                React.createElement(Grid, { className: "widget-filter-panel report-builder-setting", item: true, xs: 12, sm: 2 },
                    React.createElement(ReportSettingPanel, { isShowLoadDataButton: false, isResetSetting: isResetReportSetting, requestReportDataAction: isPreviewReport > -1 ? true : false, onLoadReportData: function (data) { return onLoadReportData(data, isPreviewReport); }, publisherIds: publisherIds, onUpdateDuration: function (duration) { return updateDuration(duration); }, dateRange: duration, isAllPlatform: true, isAllMedia: true, isAllLabel: false, isAllPubdeskInventory: true, onResetSettingSuccess: function () { return setResetReportSetting(false); }, onChangeSortData: onChangeSortData, onSaveDefaultSetting: function (settingData, forceLoadData) { return onClickSaveDefaultSetting(settingData, forceLoadData); }, selectedReportGroup: reportGroupData, defaultSetting: defaultSetting, isSaveDefaultSetting: isSaveDefaultSetting })),
                React.createElement(Grid, { item: true, xs: 12, sm: 10 },
                    React.createElement("div", { className: "report-builder-wrapper" },
                        React.createElement("div", { className: "info-report-group" },
                            React.createElement("span", null, "1"),
                            React.createElement("span", { className: "title-report" }, t("report_builder.report_group_info"))),
                        React.createElement("form", { className: "content-report-group", noValidate: true, autoComplete: "off" },
                            React.createElement("div", { className: "form-content-report-group" },
                                React.createElement("div", { className: "label-content-report-group" },
                                    React.createElement("span", null, "1.1"),
                                    React.createElement("span", { className: "title-report" }, t("report_builder.report_group_name"))),
                                React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement(TextField, { error: errorList && errorList.reportGroup && errorList.reportGroup.name ? true : false, helperText: errorList && errorList.reportGroup && errorList.reportGroup.name ? errorList.reportGroup.name : "", className: "input-report-group", value: reportGroupData.name, placeholder: t("report_builder.placeholder_report_group_name") || "", onChange: function (event) { return onChangeFieldReportGroup("name", event.currentTarget.value || ""); }, id: "report-group-name" }))),
                            React.createElement("div", { className: "form-content-report-group" },
                                React.createElement("div", { className: "label-content-report-group" },
                                    React.createElement("span", null, "1.2"),
                                    React.createElement("span", { className: "title-report" }, t("report_builder.report_group_description"))),
                                checkInternalUser() ? React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement("div", { className: "text-title-area-input-description" },
                                            React.createElement("span", null, t("report_builder.report_group_description_internal_label"))),
                                        React.createElement("div", { className: "text-area-input-description" },
                                            React.createElement(FormControl, { className: "text-area-input-description-form", variant: "outlined" },
                                                React.createElement(OutlinedInput, { id: "outlined-adornment-weight", className: "input-text-area-description", "aria-describedby": "outlined-weight-helper-text", value: reportGroupData.description, inputProps: {
                                                        'aria-label': 'weight',
                                                    }, onChange: function (event) { return onChangeFieldReportGroup("description", event.currentTarget.value || ""); }, labelWidth: 0 }))))) : null,
                                React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement("div", { className: "text-title-area-input-description" },
                                            React.createElement("span", null, t("report_builder.report_group_description_label"))),
                                        React.createElement("div", { className: "text-area-input-description" },
                                            React.createElement(FormControl, { className: "text-area-input-description-form", variant: "outlined" },
                                                React.createElement(OutlinedInput, { id: "outlined-adornment-weight", className: "input-text-area-description", "aria-describedby": "outlined-weight-helper-text", value: reportGroupData.descriptionExternal, inputProps: {
                                                        'aria-label': 'weight',
                                                    }, onChange: function (event) { return onChangeFieldReportGroup("descriptionExternal", event.currentTarget.value || ""); }, labelWidth: 0 })))))),
                            React.createElement("div", { className: "form-content-report-group" },
                                React.createElement("div", { className: "label-content-report-group" },
                                    React.createElement("span", null, "1.3"),
                                    React.createElement("span", { className: "title-report" }, t("report_builder.report_group_publisher"))),
                                checkRoleAdminAndOperator() ? React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement("div", { className: "text-title-area-input-description" },
                                            React.createElement("span", null, t("report_builder.display_dashboard"))),
                                        React.createElement("div", { className: "text-area-input-description" },
                                            React.createElement(FormControl, { className: "text-area-input-description-form", variant: "outlined" },
                                                React.createElement(SelectMaterial, { value: reportGroupData.displayDashboard, options: [
                                                        { value: "PUBLISHER", label: "Publisher Dashboard" },
                                                        { value: "MASTER", label: "Master Dashboard" }
                                                    ], onSelect: function (event) { return onChangeFieldReportGroup("displayDashboard", event.target.value || ""); } }))))) : null,
                                (checkRoleAdminAndOperator() && reportGroupData.displayDashboard == "PUBLISHER") || !checkRoleAdminAndOperator() ? React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement("div", null,
                                            React.createElement("span", null, t("report_builder.report_group_publisher_label"))),
                                        React.createElement("div", { className: "dropdown-publisher" },
                                            React.createElement("div", { className: "dropdown-publisher-head" },
                                                React.createElement("div", null,
                                                    React.createElement(Checkbox, { disabled: enablePublisher() ? false : true, key: "select-all-publisher", label: t("report_builder.all_publisher"), value: "applyForAll", checked: reportGroupData.applyForAll, classes: {
                                                            label: "select-all-publisher"
                                                        }, onChecboxValueChanged: onChangeApplyForAll })),
                                                React.createElement(CheckBoxList, { disabled: reportGroupData.applyForAll || !enablePublisher(), isCheckAll: false, data: publisherList, onChangeCheckbox: onChangePublisher })),
                                            React.createElement("div", { className: "component-error-text" }, errorList && errorList.reportGroup && errorList.reportGroup.publisherIds ? errorList.reportGroup.publisherIds : "")))) : null),
                            checkRoleAdminAndOperator() ? React.createElement("div", { className: "form-content-report-group" },
                                React.createElement("div", { className: "label-content-report-group" },
                                    React.createElement("span", null, "1.4"),
                                    React.createElement("span", { className: "title-report" }, t("report_builder.platforms_selection"))),
                                React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement(ToggleSwitch, { id: "newsletter", small: true, checked: reportGroupData.showPlatformFilter, onChange: function (value) { return onChangeFieldReportGroup("showPlatformFilter", value); } })))) : null,
                            checkRoleAdminAndOperator() ? React.createElement("div", { className: "form-content-report-group" },
                                React.createElement("div", { className: "label-content-report-group" },
                                    React.createElement("span", null, "1.5"),
                                    React.createElement("span", { className: "title-report" }, t("report_builder.platforms_list_selection"))),
                                React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement(ToggleSwitch, { id: "newsletter", small: true, checked: reportGroupData.showPlatformList, onChange: function (value) { return onChangeFieldReportGroup("showPlatformList", value); } })))) : null,
                            React.createElement("div", { className: "form-content-report-group" },
                                React.createElement("div", { className: "label-content-report-group" },
                                    checkRoleAdminAndOperator() ? React.createElement("span", null, "1.6") : React.createElement("span", null, "1.4"),
                                    React.createElement("span", { className: "title-report" }, t("report_builder.status"))),
                                React.createElement("div", { className: "input-content-report-group" },
                                    React.createElement("div", { className: "input-description-report-group" },
                                        React.createElement(ToggleSwitch, { id: "newsletter", small: true, checked: reportGroupData.status == "ACTIVE" ? true : false, onChange: function (value) { return onChangeFieldReportGroup("status", value ? "ACTIVE" : "INACTIVE"); } }))))),
                        reportTypeData.map(function (reportType, index) {
                            if (!reportType)
                                return null;
                            return (React.createElement(Fragment, { key: index },
                                React.createElement(Grid, { container: true, className: "info-report-type", direction: "row", alignItems: "center" },
                                    React.createElement(Grid, { item: true },
                                        React.createElement(Grid, { container: true, direction: 'column', alignItems: "center" },
                                            index && index > 0 ? React.createElement(IconButton, { color: "inherit", onClick: function () { return incrementReportOrder(index); }, size: "small", classes: { colorInherit: "ic-remove" }, title: "Increment Report Type Order", className: "ic-edit", "aria-label": "Increment Report Type Order", component: "span" },
                                                React.createElement(ArrowUpward, { fontSize: "small" })) : null,
                                            index < (reportTypeData.length - 1) ? React.createElement(IconButton, { color: "inherit", onClick: function () { return decrementReportOrder(index); }, size: "small", classes: { colorInherit: "ic-remove" }, title: "Decrement Report Type Order", className: "ic-edit", "aria-label": "Decrement Report Type Order", component: "span" },
                                                React.createElement(ArrowDownward, { fontSize: "small" })) : null)),
                                    React.createElement(Grid, { item: true },
                                        React.createElement("span", null,
                                            "2-",
                                            index + 1)),
                                    React.createElement(Grid, { item: true },
                                        React.createElement("span", { className: "title-report" }, t("report_builder.report_type_info_1") + (" " + (index + 1) + " ") + t("report_builder.report_type_info_2")))),
                                React.createElement("form", { key: index, className: "content-report-group", noValidate: true, autoComplete: "off" },
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.1"),
                                            React.createElement("span", { className: "title-report" }, t("report_builder.report_type_name"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-presentation-group" },
                                                React.createElement(TextField, { value: reportType.name, error: errorList && errorList["reportType"] && errorList["reportType"][reportType.displayOrder] && errorList["reportType"][reportType.displayOrder]["name"] ? true : false, helperText: errorList && errorList["reportType"] && errorList["reportType"][reportType.displayOrder] && errorList["reportType"][reportType.displayOrder]["name"] ? errorList["reportType"][reportType.displayOrder]["name"] : "", className: "input-report-group", placeholder: t("report_builder.report_type_name"), InputProps: {
                                                        endAdornment: React.createElement(InputAdornment, { position: "end" },
                                                            React.createElement("div", { className: "end-of-report-type" },
                                                                React.createElement("a", { onClick: function () { return onCloneReportType(reportType); }, className: "clone-report-type" }, t("report_builder.clone_report_type")),
                                                                reportTypeData.length > 1 ? React.createElement("a", { onClick: function () { return onDeleteReportType(index); }, className: "clone-report-type" },
                                                                    React.createElement("img", { src: RemoveIcon })) : null)),
                                                    }, onChange: function (event) { return onChangeFieldReportType("name", event.currentTarget.value || "", index); }, id: "report-group-name" })))),
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.2"),
                                            React.createElement("span", { className: "title-report" }, t("report_builder.presentation_type"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-presentation-group" },
                                                React.createElement(DndProvider, { backend: HTML5Backend },
                                                    React.createElement(ChipWrapper, { data: reportType.presentationList, isAllowDrag: true, onChangeMetric: function (presentationTypes) { return changePresentationType(presentationTypes, index); } })),
                                                React.createElement("div", { className: "input-presentation-multiple-chart" },
                                                    React.createElement("span", { className: "input-presentation-multiple-chart-label" }, t("report_builder.biaxial_graph")),
                                                    React.createElement("div", { className: "input-presentation-multiple-chart-chip" },
                                                        React.createElement(DndProvider, { backend: HTML5Backend },
                                                            React.createElement(ChipWrapper, { data: reportType.presentationMultipleChartList, multipleIcon: true, isAllowDrag: true, onChangeMetric: function (presentationTypes) { return changePresentationType(presentationTypes, index, true); } })))),
                                                React.createElement("div", { className: "component-error-text" }, errorList && errorList["reportType"] && errorList["reportType"][reportType.displayOrder] && errorList["reportType"][reportType.displayOrder]["presentationType"] ? errorList["reportType"][reportType.displayOrder]["presentationType"] : "")))),
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement(Grid, { container: true, className: "action-label-report-type", direction: "row", justify: "space-between", alignContent: "center" },
                                                React.createElement(Grid, { item: true },
                                                    React.createElement("span", null, "2.3"),
                                                    React.createElement("span", { className: "title-report" }, t("report_builder.report_type_metric"))),
                                                React.createElement(Grid, { item: true },
                                                    React.createElement("a", { onClick: function () { return onShowMetricChip(index); }, className: "hide-list-metric-report" }, t("report_builder.close_list_metric"))))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement(ChipMetrics, { publishers: reportType.publisherList, showMetrics: reportType.showMetrics, data: null, metrics: reportType.metricList, metricSelectedList: reportType.metricSelectedList, onChangeMetric: function (metrics) { return onChangeMetrics(metrics, index); } }),
                                            React.createElement("div", { className: "component-error-text" }, renderErrorMetrics(reportType)))),
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.4"),
                                            React.createElement("span", { className: "title-report" }, t("report_builder.duplicate_request"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-description-report-group" },
                                                React.createElement(ToggleSwitch, { id: "newsletter", key: index, small: true, checked: reportType.requestCount, onChange: function (value) { return onChangeFieldReportType("requestCount", value, index); } })))),
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.5"),
                                            React.createElement("span", { className: "title-report" }, t("report_builder.select_dimension"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-presentation-group" },
                                                React.createElement(DndProvider, { backend: HTML5Backend },
                                                    React.createElement(ChipWrapper, { data: reportType.dimensionList, multiple: true, isAllowDrag: true, onChangeMetric: function (dimensions) { return onChangeSelectedDimension(dimensions, index); } })),
                                                React.createElement("div", { className: "component-error-text" }, renderErrorDimension(reportType))))),
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.6"),
                                            React.createElement("span", { className: "title-report" }, t("report_builder.preview_data"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-preview-group" },
                                                React.createElement("button", { className: "btn-pb-primary", onClick: function (e) {
                                                        e.preventDefault();
                                                        setPreviewReport(index);
                                                    } }, isLoadingPreviewReport ?
                                                    React.createElement(CircularProgress, { className: "loading-progress", size: 14 }) :
                                                    React.createElement("span", null, t('report_builder.preview_display'))),
                                                React.createElement("button", { className: "btn-pb-default ml-5", onClick: function (e) {
                                                        e.preventDefault();
                                                        if (reportType.isPreviewReport) {
                                                            setPreviewReport(-1);
                                                            var reportTypes = _.cloneDeep(reportTypeData);
                                                            reportTypes[index].isPreviewReport = false;
                                                            setReportTypeData(reportTypes);
                                                        }
                                                    } }, t('report_builder.hide_preview_display')),
                                                React.createElement("span", { className: "note-preview-display" }, t("report_builder.note_preview_display"))),
                                            React.createElement("div", { className: "component-error-text" }, reportType.isValidatePlatformReport ? t("report_builder.validate_preview_report") : ""))),
                                    React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.7"),
                                            React.createElement("span", { className: "title-report" }, t("report_builder.status"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-description-report-group" },
                                                React.createElement(ToggleSwitch, { id: "newsletter", key: index, small: true, checked: reportType.status == "ACTIVE" ? true : false, onChange: function (value) { return onChangeFieldReportType("status", value ? "ACTIVE" : "INACTIVE", index); } })))),
                                    checkDisplayScheduleReportSetting(reportType) ? React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("span", null, "2.8"),
                                            React.createElement("span", { className: "title-report" }, t("schedule_report.title"))),
                                        React.createElement("div", { className: "input-content-report-group" },
                                            React.createElement("div", { className: "input-description-report-group" },
                                                React.createElement("button", { className: "btn-pb-primary", onClick: function (e) {
                                                        e.preventDefault();
                                                        history.push("/schedule-report/" + reportGroupData.id + "/" + reportType.id + "/create");
                                                    } },
                                                    React.createElement("span", null, t('schedule_report.schedule_report_setting')))))) : null,
                                    reportType.isPreviewReport ? React.createElement(PreviewReportWrapper, { previewReport: reportType.isPreviewReport, reportTypeData: reportType, metrics: metricList, downloadImage: false, onChangeDownloadImage: function () { }, presentationType: reportType.presentationType, settingData: filterSettingData, onLoadFilterReport: function () { return setPreviewReport(-1); }, onchangeLoadingPreview: function (value) { return setLoadingPreviewReport(value); }, sortMedias: sortMedias, sortInventories: sortInventories, sortPlatforms: sortPlatforms, sortPlatformInventories: sortPlatformInventories, sortSubPlatformGroups: sortSubPlatformGroups, sortPlatformGroups: sortPlatformGroups }) : null,
                                    index == (reportTypeData.length - 1) ? React.createElement("div", { className: "form-content-report-group" },
                                        React.createElement("div", { className: "label-content-report-group" },
                                            React.createElement("div", { className: "add-report-type" },
                                                React.createElement("div", { className: "btn-add-report-type", onClick: addReportType },
                                                    React.createElement("img", { src: PlusIcon, className: "icon-btn" }),
                                                    React.createElement("p", null, "\u30AB\u30FC\u30C9\u3092\u8FFD\u52A0"))))) : null)));
                        })))),
            React.createElement("div", { className: "fixed-bottom-panel" },
                errorList &&
                    ((errorList.reportType && Object.keys(errorList.reportType).length) || (errorList.reportGroup && Object.keys(errorList.reportGroup).length)) ?
                    React.createElement("div", { className: "component-error-text" }, t('report_builder.validate_enough')) : null,
                React.createElement("a", { className: "btn-pb-default-2 btn-back-to-report", href: "#/report" }, t("report_builder.btn_back")),
                builderType == "clone" || builderType == "create" ? React.createElement("button", { className: "btn-pb-primary " + (!checkEnableCreateReport() ? "btn-pb-primary-disabled" : ""), disabled: !checkEnableCreateReport(), onClick: function () { return onUpdateReportSetting(EActionType.Create); } }, t('report_builder.save')) : null,
                builderType == "edit" ? React.createElement("button", { className: "btn-pb-primary " + (!checkEnableCreateReport() ? "btn-pb-primary-disabled" : ""), disabled: !checkEnableCreateReport(), onClick: function () { return onUpdateReportSetting(EActionType.Create); } }, t('report_builder.save_as')) : null,
                builderType == "edit" ? React.createElement("button", { className: "btn-pb-primary " + (disableEdit() || !checkEnableEditReport() ? "btn-pb-primary-disabled" : ""), disabled: disableEdit() || !checkEnableEditReport(), onClick: function () { return onUpdateReportSetting(EActionType.Edit); } }, t('report_builder.edit')) : null),
            React.createElement(Dialog, { open: isOpenDialogGAValidation, onClose: handleCloseOpenDialogGA, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", BackdropProps: {
                    classes: {
                        root: "dialog-calendar-backdrop"
                    }
                } },
                React.createElement(DialogTitle, { id: "alert-dialog-title" }, "Validation GA Metric"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, "Sorry! We don't support GA metrics (Session, PageView, Unique User) with selected dimensions. GA metrics are only supported at Media Level")),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: handleCloseOpenDialogGA, color: "primary" }, "OK"))),
            messageReportSuccess ? React.createElement(Snackbar, { open: true, anchorOrigin: { vertical: "top", horizontal: "right" }, autoHideDuration: 1000, onClose: handleCloseAlert },
                React.createElement(MuiAlert, { elevation: 6, variant: "filled", severity: "success" }, messageReportSuccess)) : null,
            messageReportError ? React.createElement(Snackbar, { open: true, anchorOrigin: { vertical: "top", horizontal: "right" }, autoHideDuration: 1000, onClose: handleCloseAlert },
                React.createElement(MuiAlert, { elevation: 6, variant: "filled", severity: "error" }, messageReportError)) : null,
            messageDeleteSuccess ? React.createElement(Snackbar, { open: true, anchorOrigin: { vertical: "top", horizontal: "right" }, autoHideDuration: 1000, onClose: handleCloseAlert },
                React.createElement(MuiAlert, { elevation: 6, variant: "filled", severity: "success" }, messageDeleteSuccess)) : null,
            messageDeleteError ? React.createElement(Snackbar, { open: true, anchorOrigin: { vertical: "top", horizontal: "right" }, autoHideDuration: 1000, onClose: handleCloseAlert },
                React.createElement(MuiAlert, { elevation: 6, variant: "filled", severity: "error" }, messageDeleteError)) : null,
            React.createElement(DialogConfirm, { open: openConfirmModal, handleClose: handleCloseConfirmModal, title: "A default filter is exist, do you want to save changes to the default filter?", onSave: onSaveDefaultSetting, actionName: t("common.save") }))));
};
function mapStateToProps(state) {
    return {
        publisherData: publisherData(state)
    };
}
export default connect(mapStateToProps)(ReportPage);
